var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { services, getIntials } from '../../../shared';
import { AccordionItem, Button, Container, PageHeading, Pill } from '../../shared';
import { CaseDetails } from '../../sections/case-details/case-details';
import { formatAddress } from '../../../shared/utils';
import { ClientApplicants } from '../../sections/client-applicants/client-applicants';
import { CaseTracking } from '../../sections';
import { Notes } from '../../sections/notes/notes';
import { ApplicationStatus } from '../../../shared/types/enums';
import { Dialog } from '../../shared/dialog/dialog';
import { questionCodeName } from './../../../shared/types/constants';
import { UploadDocument } from '../../sections/upload-document/upload-document';
export var CasePage = function () {
    var _a;
    var caseId = useParams().caseId;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(), caseDetails = _c[0], setCaseDetails = _c[1];
    var _d = useState(), customerDetails = _d[0], setCustomerDetails = _d[1];
    var _e = useState(), applicationQuestions = _e[0], setApplicationQuestions = _e[1];
    var _f = useState([]), notes = _f[0], setNotes = _f[1];
    var _g = useState(), modalVisible = _g[0], setModalVisible = _g[1];
    var _h = useState(), cancelModalVisible = _h[0], setCancelModalVisible = _h[1];
    var _j = useState(), cancelMessage = _j[0], setCancelMessage = _j[1];
    var _k = useState(), workflowSteps = _k[0], setWorkflowSteps = _k[1];
    var _l = useState(), caseStages = _l[0], setCaseStages = _l[1];
    var _m = useState(), morgageAddressDetails = _m[0], setAddressDetails = _m[1];
    var _o = useState(''), titleSeperator = _o[0], setTitleSeperator = _o[1];
    var _p = useState(0), customerIdForUpload = _p[0], setCustomerIdForUpload = _p[1];
    var _q = useState(), documents = _q[0], setDocuments = _q[1];
    var stageComponentId = useRef();
    var _r = useState(0), referenceFrom = _r[0], setreferenceFrom = _r[1];
    var _s = useState(false), reloadUpdate = _s[0], setReloadUpdate = _s[1];
    var fetchDocuments = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var docs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCustomerDocuments(id)];
                case 1:
                    docs = (_a.sent()).data;
                    return [2 /*return*/, docs];
            }
        });
    }); };
    var fetchNotes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var noteData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getNotes(Number(caseId))];
                case 1:
                    noteData = (_a.sent()).data;
                    setNotes(noteData);
                    return [2 /*return*/];
            }
        });
    }); };
    var history = useHistory();
    var getWorkflowDetails = function (loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var workflow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getDynamicWorkflow(Number(caseId), loanPurposeId)];
                case 1:
                    workflow = (_a.sent()).data;
                    setWorkflowSteps(workflow.workflowSteps);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var activeCase, caseDetailsData, customerDetailsData, fees, caseDetails, caseStages, questionAddress, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    activeCase = Number(caseId);
                    return [4 /*yield*/, services.getCase(activeCase)];
                case 1:
                    caseDetailsData = (_b.sent()).data;
                    return [4 /*yield*/, services.getCustomer(caseDetailsData === null || caseDetailsData === void 0 ? void 0 : caseDetailsData.customerId)];
                case 2:
                    customerDetailsData = (_b.sent()).data;
                    return [4 /*yield*/, services.getPaidFees(caseDetailsData === null || caseDetailsData === void 0 ? void 0 : caseDetailsData.id)];
                case 3:
                    fees = (_b.sent()).data;
                    setCancelMessage(((fees === null || fees === void 0 ? void 0 : fees.filter(function (fee) { return fee.isPaid; }).length) > 0 ? 'Fees have been paid for this case. ' : '') +
                        'Are you sure you want to cancel this case?');
                    return [4 /*yield*/, services.getCaseDetails(activeCase)];
                case 4:
                    caseDetails = (_b.sent()).data;
                    return [4 /*yield*/, services.getCaseTracking(activeCase)];
                case 5:
                    caseStages = (_b.sent()).data;
                    questionAddress = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.find(function (question) { return question.dataType === questionCodeName.addressCode; });
                    if (!((questionAddress === null || questionAddress === void 0 ? void 0 : questionAddress.value) && (questionAddress === null || questionAddress === void 0 ? void 0 : questionAddress.value) != '')) return [3 /*break*/, 7];
                    _a = setAddressDetails;
                    return [4 /*yield*/, services.getAddress(Number(questionAddress.value))];
                case 6:
                    _a.apply(void 0, [(_b.sent()).data]);
                    setTitleSeperator('-');
                    _b.label = 7;
                case 7:
                    setCaseStages(caseStages);
                    setApplicationQuestions(caseDetails);
                    setCaseDetails(caseDetailsData);
                    setCustomerDetails(customerDetailsData);
                    fetchNotes();
                    getWorkflowDetails(caseDetailsData === null || caseDetailsData === void 0 ? void 0 : caseDetailsData.loanPurposeId);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var cancelCase = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.cancelCase(caseDetails.id)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchData()];
                case 2:
                    _a.sent();
                    hideCancelCaseModal();
                    return [2 /*return*/];
            }
        });
    }); };
    var hideModal = function () {
        setModalVisible(false);
    };
    var showCanceCaseModal = function (e, reference) {
        setCancelModalVisible(true);
    };
    var hideCancelCaseModal = function () {
        setCancelModalVisible(false);
    };
    var showModal = function (e, reference) {
        stageComponentId.current = Number(e.currentTarget.getAttribute('data-value'));
        setCustomerIdForUpload(Number(e.currentTarget.getAttribute('data-value')));
        setModalVisible(true);
        setreferenceFrom(reference);
    };
    var loadDocumentGrid = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var docs, docsCopy;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, fetchDocuments(customerId)];
                case 1:
                    docs = _d.sent();
                    docsCopy = new Map();
                    docsCopy.set(customerId, docs);
                    setDocuments(docsCopy);
                    setReloadUpdate(true);
                    if (((_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_c = (_b = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _b === void 0 ? void 0 : _b.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                        setReloadUpdate(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var UploadDocCaseTracking = function () { return __awaiter(void 0, void 0, void 0, function () {
        var activeCase, caseTrackingData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    activeCase = Number(caseId);
                    return [4 /*yield*/, services.getCaseTracking(activeCase)];
                case 1:
                    caseTrackingData = (_a.sent()).data;
                    setCaseStages(caseTrackingData);
                    return [2 /*return*/];
            }
        });
    }); };
    var continueCase = function (e) {
        history.push("/cases/application/".concat(e.currentTarget.getAttribute('data-value')));
    };
    var updateCustomerDetails = function (updatedCustomerDetails) {
        setCustomerDetails(updatedCustomerDetails);
    };
    var uploadCaseStageDocument = function (documentToUpload) { return __awaiter(void 0, void 0, void 0, function () {
        var result, targetComponent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    documentToUpload.id = stageComponentId.current;
                    return [4 /*yield*/, services.uploadStageDocument(documentToUpload, stageComponentId.current)];
                case 1:
                    result = _a.sent();
                    targetComponent = null;
                    if (!!(caseStages === null || caseStages === void 0 ? void 0 : caseStages.find(function (stage) {
                        var _a;
                        return ((_a = stage.components) === null || _a === void 0 ? void 0 : _a.filter(function (component) {
                            var isTarget = component.stageComponentId == stageComponentId.current;
                            if (isTarget)
                                targetComponent = component;
                            return isTarget;
                        }).length) > 0;
                    }))) {
                        targetComponent.modifiedOn = result.data.modifiedOn;
                        setCaseStages(__spreadArray([], caseStages, true));
                    }
                    UploadDocCaseTracking();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (caseDetails === null || caseDetails === undefined || Object.keys(caseDetails).length === 0)
            fetchData();
    }, [caseDetails]);
    if (isLoading) {
        return React.createElement("p", null, "Loading...");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "case-wrapper" },
            React.createElement(Dialog, { message: cancelMessage, show: cancelModalVisible, handleClose: hideCancelCaseModal, submit: cancelCase, showYesButton: true, modalType: "Info" }),
            React.createElement(PageHeading, { headingLevel: 2, title: "Case ".concat(caseId), initials: getIntials(customerDetails.firstName, customerDetails.surname), subText: "".concat(customerDetails.firstName, " ").concat(customerDetails.surname, " ").concat(titleSeperator, " ").concat(formatAddress(morgageAddressDetails)), progress: React.createElement(Pill, { status: caseDetails.applicationStatusId }), mb: 6 }),
            React.createElement(UploadDocument, { customerId: customerIdForUpload, reloadDocumentGrid: loadDocumentGrid, show: modalVisible, handleClose: hideModal, uploadCaseStageDocument: uploadCaseStageDocument, referenceFrom: referenceFrom, isEmailSend: true }),
            React.createElement(Container, { fullWidth: true },
                React.createElement("div", { className: "l-grid grid-wrapper" },
                    React.createElement("div", { className: "l-grid_span-12 l-grid_span-3@bp20 grid-border_blue" },
                        React.createElement(AccordionItem, { heading: "Applicants", count: (_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _a === void 0 ? void 0 : _a.length },
                            React.createElement(ClientApplicants, { caseDetails: caseDetails, onUpdate: updateCustomerDetails, showUploadModal: function (event) { return showModal(event, 1); }, reloadUpdate: reloadUpdate }))),
                    React.createElement("div", { className: "l-grid_span-12 l-grid_span-6@bp20 grid-border_orange" },
                        React.createElement(AccordionItem, { heading: "Case Tracking", mb: 4, extendClass: "c-case-tracking" },
                            React.createElement("div", { className: "l-grid c-case-tracking-desktop" },
                                React.createElement("div", { className: "l-grid_span-4 u-mb-6" },
                                    React.createElement(Button, { variant: "outline", width: "full", type: "button", onClick: function (event) { return showCanceCaseModal(event, 0); }, childClasses: "c-case-cancel", disabled: caseDetails.applicationStatusId === ApplicationStatus.Closed },
                                        React.createElement("b", null, "Cancel Case"))),
                                React.createElement("div", { className: "l-grid_span-8 u-mb-6" },
                                    React.createElement(Button, { variant: "primary", width: "full", type: "button", onClick: continueCase, disabled: !(caseDetails.applicationStatusId === ApplicationStatus.Active), dataValue: caseDetails.id },
                                        React.createElement("b", null, "Continue Mortgage Case")))),
                            React.createElement(CaseTracking, { workflowSteps: workflowSteps, caseStages: caseStages, caseId: Number(caseId), customerId: caseDetails.customerId, setCaseStages: setCaseStages, showUploadModal: function (event) { return showModal(event, 2); } })),
                        React.createElement(AccordionItem, { heading: "Loan Details", extendClass: "c-case-details" },
                            React.createElement(CaseDetails, { applicationQuestions: applicationQuestions, address: morgageAddressDetails }))),
                    React.createElement("div", { className: "l-grid_span-12 l-grid_span-3@bp20 grid-border_green" },
                        React.createElement(AccordionItem, { heading: "Notes", count: notes === null || notes === void 0 ? void 0 : notes.length },
                            React.createElement(Notes, { notes: notes, caseId: Number(caseId), customerId: customerDetails.id, fetchData: fetchNotes })))))),
        React.createElement("div", { className: "l-grid c-case-tracking-controls c-case-tracking-mobile" },
            React.createElement("div", { className: "l-grid_span-6" },
                React.createElement(Button, { variant: "outline", width: "full", type: "button", onClick: function (event) { return showModal(event, 0); }, childClasses: "c-case-cancel", disabled: caseDetails.applicationStatusId === ApplicationStatus.Closed },
                    React.createElement("b", null, "Cancel"))),
            React.createElement("div", { className: "l-grid_span-6" },
                React.createElement(Button, { variant: "primary", width: "full", type: "button", onClick: continueCase, disabled: !(caseDetails.applicationStatusId === ApplicationStatus.Active), dataValue: caseDetails.id },
                    React.createElement("b", null, "Continue"))))));
};
